import { useState, useEffect } from "react";
import PageTitle from "../../../components/PageTitle";
import Button from "../../../components/Button";
// import SchedulerCalendar from "../../../components/Scheduler";
import Modal from "../../../components/Modal";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import useStyles from "../styles";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Grid } from "@mui/material";
import { ClassType, Weekdays, Subject, ClassLevel } from "../../../utils/DropDown";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
import PageLoader from "../../../components/PageLoader";
// import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import ButtonCount from "../../../components/ButtonCount";
import Permission from "../../error/Permission";
import useWindowSize from "../../../hooks/useWindow";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";
import { useUpload as uploadFileService } from "../../../hooks/useUpload";
import Layout from "../../../components/Layout";
import { Link } from "react-router-dom";
import { useUserState } from "../../../context/UserContext";
import { accessViewStudentsInClass } from "../../../data/roles";

const CLASS_ENDPOINT = "/api/v1/class-teacher/class";

const CLASS_STUDENT_ENDPOINT = "/api/v1/class/students";
const AWARD_POINTS_ENDPOINT = "/api/v1/points/award-points";

const EmployeeAllClasses = () => {
  const [value, setValue] = useState("");
  // const [searchResult, setSearchResult] = useState([]);
  const [classData, setClassData] = useState([]);
  const { userRole } = useUserState();
  const [physicalClassData, setPhysicalClassData] = useState([]);
  const [studentClassData, setStudentClassData] = useState({});
  const [searchResult, setSearchResult] = useState([]);

  const [isPageLoading, setIsPageLoading] = useState(false);

  const [awardModal, setAwardModal] = useState(false);

  const [awardData, setAwardData] = useState({
    classId: "",
    studentId: "",
    points: "",
    reason: "",
    tag: "",
    file: null
  });
  const [studentOptions, setStudentOptions] = useState([]);
  const [isAwardLoading, setIsAwardLoading] = useState(false);

  const tags = ["Participation", "Homework", "Improvement", "Behavior"];

  const classes = useStyles();
  const [addtimetableModal, setAddTimeTableModal] = useState(false);
  const [permissionDenied, setPermissionDenied] = useState(false);

  const width = useWindowSize();
  const mobile = width < 600;

  // const navigate = useNavigate();

  const handleTimeTableModal = () => {
    setAddTimeTableModal(!addtimetableModal);
  };

  const getAllStudentClass = (param) => {
    httprequest.get(`${CLASS_STUDENT_ENDPOINT}/${param}`).then((res) => {
      setStudentClassData(res?.data?.data);
      setSearchResult(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleAwardModal = () => {
    setAwardModal(!awardModal);
  };

  const getStudentsForAward = (classId) => {
    if (!classId) {
      setStudentOptions([]);

      return;
    }
    httprequest.get(`${CLASS_STUDENT_ENDPOINT}/${classId}`).then((res) => {
      setStudentOptions(res?.data?.data || []);
    }).catch(() => {
      toast.error("Failed to fetch students");
    });
  };

  const submitAwardPoints = async () => {
    if (!awardData.classId || !awardData.studentId || !awardData.points || !awardData.reason) {
      toast.error("Please fill all required fields");

      return;
    }

    setIsAwardLoading(true);
    try {
      let attachment = null;

      if (awardData.file) {
        const response = await uploadFileService(awardData.file);
        if (response.status === 200) {
          attachment = {
            upload_id: response.data.data[0].upload_id,
            file_url: response.data.data[0].file_url
          };
        } else {
          toast.error("File upload failed");
          setIsAwardLoading(false);

          return;
        }
      }
      const selectedClass = physicalClassData.find((c) => c.id === awardData.classId);

      const payload = {
        student_id: awardData.studentId,
        points: Number(awardData.points),
        tag_name: awardData.tag || "point_award",
        reason: awardData.reason,
        additional_info: {
          class: selectedClass?.class_name || ""
        }
      };

      if (attachment) {
        payload.attachment = attachment;
      }

      await httprequest.post(AWARD_POINTS_ENDPOINT, payload);
      toast.success("Points awarded successfully");
      handleAwardModal();
      setAwardData({ classId: "", studentId: "", points: "", reason: "", tag: "", file: null });
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to award points");
    } finally {
      setIsAwardLoading(false);
    }
  };

  // --| Get all my classes as a class teacher
  const getAllClasses = () => {
    setIsPageLoading(true);
    httprequest.get(CLASS_ENDPOINT).then((res) => {
      setIsPageLoading(false);
      setPhysicalClassData(res?.data?.data?.filter((clss) => clss?.class_type === "physical"));
      setClassData(res?.data?.data);
      // --| Set the value to the first ID
      const firstID = res?.data?.data?.filter((clss) => clss?.class_type === "physical")?.[0]?.id;
      setValue(firstID);
      // --| Get First Student Data;
      getAllStudentClass(firstID);
    }).catch((err) => {
      setIsPageLoading(false);
      if (err?.response?.status === 403) {
        setPermissionDenied(true);
      }
      toast.error(err?.response?.data);
    });
  };

  if (permissionDenied) {
    return <Permission />;
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
    getAllStudentClass(newValue);
  };

  const studentClassColumns = [
    {
      name: "Class Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Class Name</p>}
          {row?.class?.name || "--/--"}
        </>
      )
    },
    {
      name: "Student Name",
      // eslint-disable-next-line prefer-template
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Student Name</p>}
          {`${row?.student?.first_name} ${row?.student?.last_name}` || "-/--"}
        </>
      )
    },
    {
      name: "Gender",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Gender</p>}
          {row?.gender || "--/--"}
        </>
      )
    },
    {
      name: "Student Email",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Student Email</p>}
          {row?.email || "--/--"}
        </>
      )
    },
    {
      name: "No of Guardian",
      // eslint-disable-next-line prefer-template
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">No of Guardian</p>}
          {`${row?.guardians?.length}` || "--/--"}
        </>
      )
    },
    {
      name: "Admission Date",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Admission Date</p>}
          {row?.admission_date?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          {accessViewStudentsInClass(userRole) &&
            <Link to={`/class-activities/classes/students/${row?.student_id}`} className="table-action-icon">
              <Icon icon="fluent:eye-16-regular" />
            </Link>
          }
        </div>
      )
    }
  ];

  // --| Filter Student Class using name, email and class
  const handleStudentClass = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = studentClassData?.filter((data) => valArray?.every(
      (word) => data?.first_name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
          data?.first_name
            ?.toLowerCase()
            .includes(word.toLowerCase()) ||
          data?.gender
            ?.toLowerCase()
            .includes(word.toLowerCase()) ||
          data?.class?.name
            ?.toLowerCase()
            .includes(word.toLowerCase()) ||
                      data?.email
                        ?.toLowerCase()
                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    getAllClasses();
    // getAllEmployees();
  }, []);

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Classes"
            subtitle="View all the details of the class that you are assigned as the class teacher"
            button={
              <div className="flex gap-10">
                <Button
                  variant="primary"
                  color="btndefault"
                  onClick={handleAwardModal}
                  buttonName="Award Points"
                />
              </div>
            }
          />
          {isPageLoading ? (<PageLoader />) :
            <>
              {classData?.length ? (
                <div className="page-content">
                  <div className="padding-left-16">
                    <ButtonCount count={classData?.length} title="All classes" />
                  </div>
                  <TabContext value={value}>
                    <div className="tablist-container padding-left-16">
                      <Tabs
                        className="overide-tablist"
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        {physicalClassData?.map((data) => {
                          return (
                            <Tab key={data?.id} value={data?.id} label={data?.class_name} />
                          );
                        })}
                      </Tabs>
                    </div>
                    {classData?.map((data) => {
                      return (
                        <TabPanel key={data?.id} value={data?.id} className="tabpanel-overide">
                          <Table data={searchResult} columns={studentClassColumns} subHeader={true} pagination subHeaderComponent={
                            <TableSearch placeholder="Search here..." searchTableFunc={handleStudentClass} />}
                          />
                        </TabPanel>
                      );
                    })}
                  </TabContext>
                </div>
              ) : (
                <>
                  <ButtonCount count={classData?.length} title="View all classes" />
                  <Table data={searchResult} columns={studentClassColumns} subHeader={true} pagination subHeaderComponent={
                    searchResult?.length > 0 && (
                      <TableSearch placeholder="Search here..." searchTableFunc={handleStudentClass} />
                    )}
                  />
                </>) }
            </>
          }
          {/* Add Time Table Modal */}
          <Modal
            title="Add to Timetable"
            subtitle={
              <div>Allocate a time slot for a subject in the timetable
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Subject" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {Subject?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Class" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {ClassLevel?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <SelectGroup label="Day of week" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {Weekdays?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <SelectGroup label="Alloted Time" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {ClassType?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <SelectGroup label="Start Time" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {ClassType?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <SelectGroup label="End Time" children={
                      <select>
                        <option value="">--- Select ---</option>
                        {ClassType?.map((label) => {
                          return (
                            <option key={label.key}>{label?.text}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className={classes.modalFooterBtn}>
                  <Button variant="primary" buttonSize="full" color="btndefault" buttonName="Add to timetable" />
                </div>
              </>
            }
            isopen={addtimetableModal}
            closeModal={handleTimeTableModal}
          />

          {/* Award Points Modal */}
          <Modal
            title="Award points"
            subtitle="Recognize positive actions"
            modalContent={
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup label={<>Class <span className="input-required">*</span></>}>
                    <select
                      value={awardData.classId}
                      onChange={(e) => {
                        setAwardData({ ...awardData, classId: e.target.value, studentId: "" });
                        getStudentsForAward(e.target.value);
                      }}
                    >
                      <option value="">Select Class</option>
                      {physicalClassData?.map((cls) => (
                        <option key={cls.id} value={cls.id}>{cls.class_name}</option>
                      ))}
                    </select>
                  </SelectGroup>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup label={<>Student <span className="input-required">*</span></>}>
                    <select
                      value={awardData.studentId}
                      onChange={(e) => setAwardData({ ...awardData, studentId: e.target.value })}
                      disabled={!awardData.classId}
                    >
                      <option value="">Select Student</option>
                      {studentOptions?.map((student) => (
                        <option key={student.student?.student_id} value={student.student?.student_id}>
                          {student.student?.first_name} {student.student?.last_name}
                        </option>
                      ))}
                    </select>
                  </SelectGroup>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup label={<>Points <span className="input-required">*</span></>}>
                    <select
                      value={awardData.points}
                      onChange={(e) => setAwardData({ ...awardData, points: e.target.value })}
                    >
                      <option value="">Select Points</option>
                      {[1, 2, 3, 4, 5, 10, 15, 20].map((p) => (
                        <option key={p} value={p}>{p}</option>
                      ))}
                    </select>
                  </SelectGroup>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextAreaGroup
                    label={<>Reason <span className="input-required">*</span></>}
                    placeholder="Value"
                    value={awardData.reason}
                    onChange={(e) => setAwardData({ ...awardData, reason: e.target.value })}
                    rows={3}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label className={classes.label}>Additional Information</label>
                  <div className={classes.pickercontainer}>
                    <input type="file" className={classes.picker} onChange={(e) => setAwardData({ ...awardData, file: e.target.files[0] })} />
                    <div className={classes.uploadflex}>
                      <div><Icon icon="icon-park-outline:upload-two" className={classes.uploadicon} /></div>
                      {awardData.file ? (
                        <div>
                          <h2 className={classes.uploadtitle}>
                            {awardData.file.name}
                          </h2>
                        </div>
                      ) : (
                        <div>
                          <p className={classes.uploadtitle}>
                            Tap to Upload
                          </p>
                          <p className={classes.uploadsubtitle}>
                            SVG, PNG, JPG, GIF | 10MB max.
                          </p>
                        </div>
                      )}
                    </div>
                    <div className={classes.rightpicker}>
                      {awardData.file ? (
                        <div
                          className={classes.uploadbutton}
                          onClick={() => setAwardData({ ...awardData, file: null })}
                        >
                          <Icon icon="zondicons:minus-solid" /> Remove File
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label className={classes.label} style={{ marginBottom: "8px", display: "block" }}>Tags (optional)</label>
                  <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                    {tags.map((tag) => (
                      <div
                        key={tag}
                        onClick={() => setAwardData({ ...awardData, tag })}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "20px",
                          backgroundColor: awardData.tag === tag ? "#E6F0FF" : "#F2F4F7",
                          color: awardData.tag === tag ? "#0065FF" : "#344054",
                          cursor: "pointer",
                          fontWeight: 500
                        }}
                      >
                        {tag}
                      </div>
                    ))}
                  </div>
                </Grid>
              </Grid>
            }
            modalFooter={
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Award Points"
                  onClick={submitAwardPoints}
                  isLoading={isAwardLoading}
                />
              </div>
            }
            isopen={awardModal}
            closeModal={handleAwardModal}
          />
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default EmployeeAllClasses;
